import React from 'react';

class Footer extends React.Component {

  render() {
    return (
      <>
        <p>Created by: Miss King 👑 </p>
      </>
    );
  }
}

export default Footer;
